module.exports = __webpack_public_path__ + "static/media/carousel_fr_fintec.feac7bd4.jpg";